export interface GalleryUrlParams {
  page?: number
  pageSize?: number
  search?: string
  regions?: string[]
  statuses?: string[]
  tags?: string[]
  services?: string[]
  /** Filter to galleries with job_number but missing job details */
  needsSync?: boolean
  sortBy?: 'created_on' | 'title'
  sortDir?: 'asc' | 'desc'
  view?: 'grid' | 'table'
}

export function parseParams(search: string): GalleryUrlParams {
  const p = new URLSearchParams(search)
  return {
    page: p.get('page') ? Number(p.get('page')) : undefined,
    pageSize: p.get('pageSize') ? Number(p.get('pageSize')) : undefined,
    search: p.get('q') || undefined,
    regions: p.get('regions')?.split(',').filter(Boolean),
    statuses: p.get('statuses')?.split(',').filter(Boolean),
    tags: p.get('tags')?.split(',').filter(Boolean),
    services: p.get('services')?.split(',').filter(Boolean),
    needsSync: p.get('needsSync') === 'true' ? true : undefined,
    sortBy: (p.get('sortBy') as any) || undefined,
    sortDir: (p.get('sortDir') as any) || undefined,
    view: (p.get('view') as any) || undefined
  }
}

export function serializeParams(params: GalleryUrlParams) {
  const p = new URLSearchParams()
  if (params.page) p.set('page', String(params.page))
  if (params.pageSize) p.set('pageSize', String(params.pageSize))
  if (params.search) p.set('q', params.search)
  if (params.regions?.length) p.set('regions', params.regions.join(','))
  if (params.statuses?.length) p.set('statuses', params.statuses.join(','))
  if (params.tags?.length) p.set('tags', params.tags.join(','))
  if (params.services?.length) p.set('services', params.services.join(','))
  if (params.needsSync) p.set('needsSync', 'true')
  if (params.sortBy) p.set('sortBy', params.sortBy)
  if (params.sortDir) p.set('sortDir', params.sortDir)
  if (params.view) p.set('view', params.view)
  return p.toString()
}

// TODO: Add unit tests for stable param parsing/serialization
// - [ ] Ensure arrays serialize deterministically (sort order if needed)
// - [ ] Ignore empty values to keep URL clean
// - [ ] Provide helpers to merge partial updates without resetting unspecified fields
